import { createEvent } from "@cobuildlab/react-simple-state";
import { Bonus } from "../../shared/types";

export const OnFetchBonus = createEvent<Bonus[]>();
export const OnFetchBonusError = createEvent();
